// extracted by mini-css-extract-plugin
export default {"card":"FormConfirm_card__d8XBq","container":"FormConfirm_container__wQPnX"};